import { UPDATE_CUSTOMER_DETAILS } from 'constants/customerDetails';

export const updateCustomerDetails = (customerDetails) => ({
  type: UPDATE_CUSTOMER_DETAILS,
  customerDetails,
});
